import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Home from '../Components/Home/Home'
import Footer from '../Components/Footer/FooterOne'
import { Helmet } from "react-helmet-async";   // ✅ correct import


function HomeOne() {
    return (
        <div>
            <Helmet>
                <title>Homemade Veg Food Delivery in Coimbatore | Tickling Tummy</title>
                <meta name="description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, located in R.S. Puram. We specialize in healthy daily meal subscriptions, customized pre-order tiffin services, and gourmet event catering." />
                <meta name="keywords" content="Homemade vegetarian food Coimbatore, Pure veg meals, Daily meal subscription Coimbatore, Veg catering Coimbatore, Sunday dine-in Coimbatore, Tickling Tummy" />
                <link rel="canonical" href="https://ticklingtummy.com" />
                
                {/* Open Graph Tags */}
                <meta property="og:title" content="Homemade Veg Food Delivery in Coimbatore | Tickling Tummy" />
                <meta property="og:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, located in R.S. Puram. We specialize in healthy daily meal subscriptions, customized pre-order tiffin services, and gourmet event catering." />
                <meta property="og:image" content="https://ticklingtummy.com/assets/images/tickling-tummy-logo-coimbatore.svg" />
                <meta property="og:url" content="https://ticklingtummy.com" />
                <meta property="og:type" content="website" />
                
                {/* Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Homemade Veg Food Delivery in Coimbatore | Tickling Tummy" />
                <meta name="twitter:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, located in R.S. Puram. We specialize in healthy daily meal subscriptions, customized pre-order tiffin services, and gourmet event catering." />
                <meta name="twitter:image" content="https://ticklingtummy.com/assets/images/tickling-tummy-logo-coimbatore.svg" />
            </Helmet>

        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
  {
    "@type": "ListItem",
    "position": 1,
    "name": "Home",
    "item": "https://ticklingtummy.com"
  }
]
        }, null, 2)}
        </script>

            <HeaderOne />
            <Home />
            <Footer />

        </div>
    )
}

export default HomeOne
